var _g, _line, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "3397ef87-020e-4249-bbd8-e4c7eb929207",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 151.89,
    viewBox: "0 0 160 151.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c696728d-5668-492b-9297-95176927de14",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "3385445c-9e3d-443f-a2cf-b40fe9913fd1",
    "data-name": "<Pfad>",
    d: "M168.43,136.28C176.79,151.07,170,164,153.23,164H38.77c-16.72,0-23.57-12.93-15.2-27.72L80.8,31.15c8.33-14.34,22-15.1,30.41,0Z",
    transform: "translate(-16 -16.11)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "31e991a3-d2dd-4217-be4f-e80782abf0cb",
    "data-name": "<Pfad>",
    x1: 80,
    y1: 43.89,
    x2: 80,
    y2: 100.39,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 119.89,
    r: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 119.89,
    r: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9694c3e444a2cae4b775dd416310b798.svg";
export { ForwardRef as ReactComponent };